module.exports = __webpack_public_path__ + "static/media/publish@2x.165f1e35.jpg";